import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Banner sponsor rotante tra le sezioni della home.
 * Se non ci sono sponsor attivi, mostra placeholder "Spazio disponibile".
 */
export default function SponsorBanner({ slot = "home" }) {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api
      .get("/sponsors")
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  useEffect(() => {
    if (items.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items.length]);

  return (
    <section
      className="border-y av-hairline bg-[#0a0908]"
      data-testid={`sponsor-banner-${slot}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="text-center av-eyebrow text-[10px] mb-3 text-[#A39E93]">
          Spazio sponsor
        </div>

        {items.length === 0 ? (
          <a
            href="mailto:napolitanomaxagency@live.com?subject=Interesse%20spazio%20sponsor%20—%20NMA%20Agency"
            className="block mx-auto max-w-3xl border-2 border-dashed border-[#E5A93C]/30 rounded-xl px-6 py-8 text-center hover:border-[#E5A93C]/70 transition-colors group"
            data-testid="sponsor-empty-slot"
          >
            <div className="font-serif-display text-2xl text-[#F7F4EE]/80 group-hover:text-[#E5A93C] transition-colors">
              Il tuo brand qui.
            </div>
            <p className="text-xs text-[#A39E93] mt-2">
              Spazio disponibile · Contatta la direzione NMA per riservarlo
            </p>
          </a>
        ) : (
          <div
            className="relative mx-auto max-w-5xl flex items-center justify-center min-h-[200px]"
            data-testid="sponsor-slot"
          >
            {items.map((s, i) => (
              <a
                key={s.id}
                href={s.link || "#"}
                target={s.link ? "_blank" : "_self"}
                rel="noopener noreferrer"
                aria-label={`Sponsor ${s.name}`}
                data-testid={`sponsor-item-${s.id}`}
                className={`absolute inset-0 flex items-center justify-center transition-opacity duration-700 ${
                  i === idx ? "opacity-100" : "opacity-0 pointer-events-none"
                }`}
              >
                <img
                  src={s.image_url}
                  alt={s.name}
                  className="max-h-[190px] w-auto object-contain"
                />
              </a>
            ))}
          </div>
        )}

        {items.length > 1 && (
          <div className="flex justify-center gap-1.5 mt-4">
            {items.map((s, i) => (
              <button
                key={`dot-${s.id || i}`}
                onClick={() => setIdx(i)}
                className={`h-1.5 rounded-full transition-all ${
                  i === idx ? "w-6 bg-[#E5A93C]" : "w-1.5 bg-[#A39E93]/40"
                }`}
                aria-label={`Vai allo sponsor ${i + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
